export default function (state, getters, rootState, rootGetters) {
    return rootState.settings.certificates.load || state.list.loading;
}